import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Engagements',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'engagements',
                },
              },
              subqueries: {
                engagements: {
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'projRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'projRecordId',
                            },
                          },
                          {
                            '@': 'projId',
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!engagements:!engagement',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          role: {
                            '{}': {
                              value: {
                                '@.': '!role',
                              },
                            },
                          },
                          descr: {
                            '{}': {
                              value: {
                                '@.': '!descr',
                              },
                            },
                          },
                          status: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@.': '!is_current',
                                        },
                                        true,
                                      ],
                                    },
                                    'Active',
                                  ],
                                  'Inactive',
                                ],
                              },
                            },
                          },
                          projName: {
                            '{}': {
                              value: {
                                '@': 'projName',
                              },
                            },
                          },
                          employeeName: {
                            '{}': {
                              value: {
                                '@': 'employeeName',
                              },
                            },
                          },
                          activePeriods: {
                            '{}': {
                              value: {
                                '@.': '!active_periods',
                              },
                            },
                          },
                          allocationHoursOne: {
                            '{}': {
                              value: {
                                '@': 'allocationHoursOne',
                              },
                            },
                          },
                          allocationHoursTwo: {
                            '{}': {
                              value: {
                                '@': 'allocationHoursTwo',
                              },
                            },
                          },
                          allocationHoursFour: {
                            '{}': {
                              value: {
                                '@': 'allocationHoursFour',
                              },
                            },
                          },
                          allocationHoursThree: {
                            '{}': {
                              value: {
                                '@': 'allocationHoursThree',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    projId: {
                      ref: {
                        attr: 'attr:ent#!engagements#!engagement:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    projName: {
                      ref: {
                        attr: 'attr:ent#!engagements#!engagement:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!name',
                      },
                    },
                    projStatus: {
                      ref: {
                        attr: 'attr:ent#!engagements#!engagement:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!status',
                      },
                    },
                    employeeName: {
                      ref: {
                        attr: 'attr:ent#!engagements#!engagement:!employee',
                      },
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': '!name',
                      },
                    },
                    allocationStatus: {
                      ref: {
                        attr: 'attr:ent#!allocations#!allocation:!engagement',
                      },
                      target: 'ent:!allocations:!allocation',
                      selection: {
                        '@.': '!is_current',
                      },
                    },
                    allocationHoursOne: {
                      ref: {
                        attr: 'attr:ent#!allocations#!allocation:!engagement',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/7/2026',
                          },
                          start: {
                            $date: '3/1/2026',
                          },
                        },
                      },
                      target: 'ent:!allocations:!allocation',
                      selection: {
                        '@.': '!planned_weekly_hours',
                      },
                    },
                    allocationHoursTwo: {
                      ref: {
                        attr: 'attr:ent#!allocations#!allocation:!engagement',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/14/2026',
                          },
                          start: {
                            $date: '3/8/2026',
                          },
                        },
                      },
                      target: 'ent:!allocations:!allocation',
                      selection: {
                        '@.': '!planned_weekly_hours',
                      },
                    },
                    allocationHoursFour: {
                      ref: {
                        attr: 'attr:ent#!allocations#!allocation:!engagement',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/28/2026',
                          },
                          start: {
                            $date: '3/22/2026',
                          },
                        },
                      },
                      target: 'ent:!allocations:!allocation',
                      selection: {
                        '@.': '!planned_weekly_hours',
                      },
                    },
                    allocationHoursThree: {
                      ref: {
                        attr: 'attr:ent#!allocations#!allocation:!engagement',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/21/2026',
                          },
                          start: {
                            $date: '3/15/2026',
                          },
                        },
                      },
                      target: 'ent:!allocations:!allocation',
                      selection: {
                        '@.': '!planned_weekly_hours',
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                or: [
                  {
                    '=': [
                      {
                        '``': {
                          '@$': 'projRecordId',
                        },
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '``': {
                          '@$': 'projRecordId',
                        },
                      },
                      {
                        '@': 'projId',
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!engagements:!engagement',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      role: {
                        '{}': {
                          value: {
                            '@.': '!role',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      status: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!is_current',
                                    },
                                    true,
                                  ],
                                },
                                'Active',
                              ],
                              'Inactive',
                            ],
                          },
                        },
                      },
                      projName: {
                        '{}': {
                          value: {
                            '@': 'projName',
                          },
                        },
                      },
                      employeeName: {
                        '{}': {
                          value: {
                            '@': 'employeeName',
                          },
                        },
                      },
                      activePeriods: {
                        '{}': {
                          value: {
                            '@.': '!active_periods',
                          },
                        },
                      },
                      allocationHoursOne: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursOne',
                          },
                        },
                      },
                      allocationHoursSix: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursSix',
                          },
                        },
                      },
                      allocationHoursTwo: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursTwo',
                          },
                        },
                      },
                      allocationHoursFive: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursFive',
                          },
                        },
                      },
                      allocationHoursFour: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursFour',
                          },
                        },
                      },
                      allocationHoursEight: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursEight',
                          },
                        },
                      },
                      allocationHoursSeven: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursSeven',
                          },
                        },
                      },
                      allocationHoursThree: {
                        '{}': {
                          value: {
                            '@': 'allocationHoursThree',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                projId: {
                  ref: {
                    attr: 'attr:ent#!engagements#!engagement:!proj',
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!id',
                  },
                },
                projName: {
                  ref: {
                    attr: 'attr:ent#!engagements#!engagement:!proj',
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!name',
                  },
                },
                projStatus: {
                  ref: {
                    attr: 'attr:ent#!engagements#!engagement:!proj',
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!status',
                  },
                },
                employeeName: {
                  ref: {
                    attr: 'attr:ent#!engagements#!engagement:!employee',
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!name',
                  },
                },
                allocationStatus: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!is_current',
                  },
                },
                allocationHoursOne: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '5/10/2026',
                      },
                      start: {
                        $date: '5/4/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursSix: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '6/14/2026',
                      },
                      start: {
                        $date: '6/8/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursTwo: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '5/17/2026',
                      },
                      start: {
                        $date: '5/11/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursFive: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '6/7/2026',
                      },
                      start: {
                        $date: '6/1/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursFour: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '5/31/2026',
                      },
                      start: {
                        $date: '5/25/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursEight: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '6/28/2026',
                      },
                      start: {
                        $date: '6/22/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursSeven: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '6/21/2026',
                      },
                      start: {
                        $date: '6/15/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
                allocationHoursThree: {
                  ref: {
                    attr: 'attr:ent#!allocations#!allocation:!engagement',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '5/24/2026',
                      },
                      start: {
                        $date: '5/18/2026',
                      },
                    },
                  },
                  target: 'ent:!allocations:!allocation',
                  selection: {
                    '@.': '!planned_weekly_hours',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'employeeName',
                  direct: {
                    '{}': {
                      name: 'Employee',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'role',
                  direct: {
                    '{}': {
                      name: 'Role',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'status',
                  direct: {
                    '{}': {
                      name: 'Role Status',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'projName',
                  direct: {
                    '{}': {
                      name: 'Project',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'activePeriods',
                  direct: {
                    '{}': {
                      name: 'Date',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursOne',
                  direct: {
                    '{}': {
                      name: '5/4-5/11',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursTwo',
                  direct: {
                    '{}': {
                      name: '5/11-5/18',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursThree',
                  direct: {
                    '{}': {
                      name: '5/18-5/25',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursFour',
                  direct: {
                    '{}': {
                      name: '5/25-6/1',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursFive',
                  direct: {
                    '{}': {
                      name: '6/1-6/8',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursSix',
                  direct: {
                    '{}': {
                      name: '6/8-6/15',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursSeven',
                  direct: {
                    '{}': {
                      name: '6/15-6/22',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'allocationHoursEight',
                  direct: {
                    '{}': {
                      name: '6/22-6/29',
                      type: 'INT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'create-engagement-modal',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
